// extracted by mini-css-extract-plugin
export default {"date":"UjjPcypa2r9rAII5Gscs"};